module.exports = __webpack_public_path__ + "static/media/searchBtnEng.3178c35b.png";